import Swiper, { Pagination, A11y } from 'swiper'
Swiper.use([Pagination, A11y])

import { renderBullet, hideClonedSlidesFromScreenReaders } from './a11y.js'
import swiperHandleKeyboardFocus from '@js/util/swiper-handle-keyboard-focus'

for (let sliderElement of document.querySelectorAll('.wpce-slider-integrated')) {
  let swiper = new Swiper(`#${sliderElement.dataset.swiperId}`, {
    loop: true,
    threshold: 30,
    spaceBetween: 65,
    autoHeight: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      bulletElement: 'button',
      clickable: 'true',
      renderBullet(index, className) {
        return renderBullet(this, index, className)
      },
    },
    a11y: {
      enabled: true,
      containerRoleDescriptionMessage: 'carousel',
      itemRoleDescriptionMessage: 'slide',
      paginationBulletMessage: null,
    },
  })

  // Hide cloned slides (for looping) from screen readers
  hideClonedSlidesFromScreenReaders(swiper)

  // Keyboard focus is not handled by Swiper.js itself
  swiperHandleKeyboardFocus(swiper)

  // Had to include manually because of a bug in chrome
  sliderElement.querySelector('.slider-button-next')?.addEventListener('click', () => {
    swiper.slideNext()
  })
  sliderElement.querySelector('.slider-button-prev')?.addEventListener('click', () => {
    swiper.slidePrev()
  })
}
